import { Link, useLoaderData } from "react-router-dom";
import * as API from "../services/expmedica";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getExpmedicaByID(params.expmedicaId);
}

export function ExpmedicaItem(props) {
  const expmedica = useLoaderData();
  const errorMessage = expmedica.message;
  console.log(expmedica);
  const expmedResp = expmedica.meta?.expmedResp;
  const expmedFecha = expmedica.meta?.metaFecha;
  const expmedTipo = expmedica.meta && expmedica.meta.expmedTipo ? expmedica.meta.expmedTipo : "";
  const expmedPeso = expmedica.meta?.expmedPeso;
  const expmedTalla = expmedica.meta?.expmedTalla;
  const expmedTemp = expmedica.meta?.expmedTemp;
  const expmedSo2 = expmedica.meta?.expmedSo2;
  const expmedAspgen = expmedica.meta?.expmedAspgen;
  const expmedOjo = expmedica.meta?.expmedOjo;
  const expmedNariz = expmedica.meta?.expmedNariz;
  const expmedBoca = expmedica.meta?.expmedBoca;
  const expmedOido = expmedica.meta?.expmedOido;
  const expmedPiel = expmedica.meta?.expmedPiel;
  const expmedFaner = expmedica.meta?.expmedFaner;
  const expmedMucos = expmedica.meta?.expmedMucos;
  const expmedOrofar = expmedica.meta?.expmedOrofar;
  const expmedCuello = expmedica.meta?.expmedCuello;
  const expmedTronc = expmedica.meta?.expmedTronc;
  const expmedExtrem = expmedica.meta?.expmedExtrem;
  const expmedAusc = expmedica.meta?.expmedAusc;
  const expmedMvesic = expmedica.meta?.expmedMvesic;
  const expmedVentbas = expmedica.meta?.expmedVentbas;
  const expmedRresp = expmedica.meta?.expmedRresp;
  const expmedFrecresp = expmedica.meta?.expmedFrecresp;
  const expmedTasent = expmedica.meta?.expmedTasent;
  const expmedAusccard = expmedica.meta?.expmedAusccard;
  const expmedFreccard = expmedica.meta?.expmedFreccard;
  const expmedRcard = expmedica.meta?.expmedRcard;
  const expmedRuidos = expmedica.meta?.expmedRuidos;
  const expmedElectroc = expmedica.meta?.expmedElectroc;
  const expmedPulscarot = expmedica.meta?.expmedPulscarot;
  const expmedPulyug = expmedica.meta?.expmedPulyug;
  const expmedInspvenart = expmedica.meta?.expmedInspvenart;
  const expmedInpecc = expmedica.meta?.expmedInpecc;
  const expmedPalp = expmedica.meta?.expmedPalp;
  const expmedAuscdig = expmedica.meta?.expmedAuscdig;
  const expmedPercus = expmedica.meta?.expmedPercus;
  const expmedInspurog = expmedica.meta?.expmedInspurog;
  const expmedLocom = expmedica.meta?.expmedLocom;
  const expmedExplrefl = expmedica.meta?.expmedExplrefl;
  const expmedReflpup = expmedica.meta?.expmedReflpup;
  const expmedRefrot = expmedica.meta?.expmedRefrot;
  const expmedSigmen = expmedica.meta?.expmedSigmen;
  const expmedParcran = expmedica.meta?.expmedParcran;
  const expmedSubconj = expmedica.meta?.expmedSubconj;
  const expmedTelang = expmedica.meta?.expmedTelang;
  const expmedEritpalm = expmedica.meta?.expmedEritpalm;
  const expmedGinec = expmedica.meta?.expmedGinec;
  const expmedTembdist = expmedica.meta?.expmedTembdist;
  const expmedEdmal = expmedica.meta?.expmedEdmal;
  const expmedRetpalm = expmedica.meta?.expmedRetpalm;
  const expmedHipparot = expmedica.meta?.expmedHipparot;
  const expmedAtdergen = expmedica.meta?.expmedAtdergen;
  const expmedJuicclin = expmedica.meta?.expmedJuicclin;

  const expmedDate = new Date(expmedica.date);
  const diffDate = (Math.abs(new Date() - expmedDate) / 36e5);

  return (
    <>
      <div id='content'>
        {expmedica.length === 0 ? (
          <div>Cargando...</div>
        ) : (
        errorMessage? (
          <p>{errorMessage}</p>
        ) : (
          <form id='formUpdatelement'>
            <fieldset id='disabledContainer' disabled='disabled'>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='expmedResp'>Responsable</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedResp'
                      required
                      type='text'
                      readOnly
                      value={expmedResp}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedFecha'>Fecha visita</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedFecha'
                      required
                      type='date'
                      readOnly
                      value={expmedFecha}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedTipo'>Tipo</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='expmedTipo'
                        readOnly
                        name='expmedTipo'
                        value={expmedTipo}
                      >
                        <option disabled value=''> -- Selecciona una opción --</option>
                        <option value='Valoración'>Valoración</option>
                        <option value='Ingreso'>Ingreso</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <h3>Inspección general</h3>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='expmedPeso'>Peso</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedPeso'
                      type='text'
                      readOnly
                      value={expmedPeso}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedTalla'>Talla</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedTalla'
                      type='text'
                      readOnly
                      value={expmedTalla}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedTemp'>Temperatura</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedTemp'
                      type='text'
                      readOnly
                      value={expmedTemp}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedSo2'>SO2 Basal</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedSo2'
                      type='text'
                      readOnly
                      value={expmedSo2}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedAspgen'>Aspecto general</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedAspgen'
                      type='text'
                      readOnly
                      value={expmedAspgen}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedOjo'>Ojo</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedOjo'
                      type='text'
                      readOnly
                      value={expmedOjo}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedNariz'>Nariz</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedNariz'
                      type='text'
                      readOnly
                      value={expmedNariz}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedBoca'>Boca</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedBoca'
                      type='text'
                      readOnly
                      value={expmedBoca}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedOido'>Oído</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedOido'
                      type='text'
                      readOnly
                      value={expmedOido}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedPiel'>Piel</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedPiel'
                      type='text'
                      readOnly
                      value={expmedPiel}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedFaner'>Faneras</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedFaner'
                      type='text'
                      readOnly
                      value={expmedFaner}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedMucos'>Mucosas</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedMucos'
                      type='text'
                      readOnly
                      value={expmedMucos}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedOrofar'>Orofaringe</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedOrofar'
                      type='text'
                      readOnly
                      value={expmedOrofar}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedCuello'>Cuello</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedCuello'
                      type='text'
                      readOnly
                      value={expmedCuello}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedTronc'>Tronco</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedTronc'
                      type='text'
                      readOnly
                      value={expmedTronc}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedExtrem'>Extremidades</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedExtrem'
                      type='text'
                      readOnly
                      value={expmedExtrem}
                    />
                  </div>
                </div>
              </div>
              <h3>Inspección por aparatos</h3>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='expmedAusc'>Auscultación respiratoria</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedAusc'
                      type='text'
                      readOnly
                      value={expmedAusc}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedMvesic'>Murmullo vesicular</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedMvesic'
                      type='text'
                      readOnly
                      value={expmedMvesic}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedVentbas'>Ventilación de bases</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedVentbas'
                      type='text'
                      readOnly
                      value={expmedVentbas}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedRresp'>Ruidos respiratorios</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedRresp'
                      type='text'
                      readOnly
                      value={expmedRresp}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedFrecresp'>
                    Frecuencia respiratoria
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedFrecresp'
                      type='text'
                      readOnly
                      value={expmedFrecresp}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedTasent'>T.A sentado</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedTasent'
                      type='text'
                      readOnly
                      value={expmedTasent}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedAusccard'>Auscultación cardíaca</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedAusccard'
                      type='text'
                      readOnly
                      value={expmedAusccard}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedFreccard'>Frecuencia cardiaca</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedFreccard'
                      type='text'
                      readOnly
                      value={expmedFreccard}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedRcard'>Soplos</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedRcard'
                      type='text'
                      readOnly
                      value={expmedRcard}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedRuidos'>Ruidos</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedRuidos'
                      type='text'
                      readOnly
                      value={expmedRuidos}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedElectroc'>Electrocardiograma</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedElectroc'
                      type='text'
                      readOnly
                      value={expmedElectroc}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedPulscarot'>Pulsos carotídeos</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedPulscarot'
                      type='text'
                      readOnly
                      value={expmedPulscarot}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedPulyug'>Pulso yugular</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedPulyug'
                      type='text'
                      readOnly
                      value={expmedPulyug}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedInspvenart'>
                    Inspección venas y arterias
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedInspvenart'
                      type='text'
                      readOnly
                      value={expmedInspvenart}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedInpecc'>Inspección digestivo</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedInpecc'
                      type='text'
                      readOnly
                      value={expmedInpecc}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedPalp'>Palpación digestivo</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedPalp'
                      type='text'
                      readOnly
                      value={expmedPalp}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedAuscdig'>Auscultación digestivo</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedAuscdig'
                      type='text'
                      readOnly
                      value={expmedAuscdig}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedPercus'>Percusión digestivo</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedPercus'
                      type='text'
                      readOnly
                      value={expmedPercus}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedInspurog'>Inspección urogenital</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedInspurog'
                      type='text'
                      readOnly
                      value={expmedInspurog}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedLocom'>Locomotor</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedLocom'
                      type='text'
                      readOnly
                      value={expmedLocom}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedExplrefl'>
                    Exploración de reflejos
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedExplrefl'
                      type='text'
                      readOnly
                      value={expmedExplrefl}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedReflpup'>Reflejos pupilares</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedReflpup'
                      type='text'
                      readOnly
                      value={expmedReflpup}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedRefrot'>Reflejo rotuliano</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedRefrot'
                      type='text'
                      readOnly
                      value={expmedRefrot}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedSigmen'>Signos meníngeos</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedSigmen'
                      type='text'
                      readOnly
                      value={expmedSigmen}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedParcran'>Pares craneales</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedParcran'
                      type='text'
                      readOnly
                      value={expmedParcran}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedSubconj'>Subictericia conjutival</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedSubconj'
                      type='text'
                      readOnly
                      value={expmedSubconj}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedTelang'>Telangiectasias</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedTelang'
                      type='text'
                      readOnly
                      value={expmedTelang}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedEritpalm'>Eritema palmar</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedEritpalm'
                      type='text'
                      readOnly
                      value={expmedEritpalm}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedGinec'>Ginecomastia</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedGinec'
                      type='text'
                      readOnly
                      value={expmedGinec}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedTembdist'>Temblor distal</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedTembdist'
                      type='text'
                      readOnly
                      value={expmedTembdist}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedEdmal'>Edemas maleolares</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedEdmal'
                      type='text'
                      readOnly
                      value={expmedEdmal}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedRetpalm'>Retracción palmar</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedRetpalm'
                      type='text'
                      readOnly
                      value={expmedRetpalm}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedHipparot'>Hipertrofia parotidea</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedHipparot'
                      type='text'
                      readOnly
                      value={expmedHipparot}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='expmedAtdergen'>
                    Atrofia dérmica generalizada
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='expmedAtdergen'
                      type='text'
                      readOnly
                      value={expmedAtdergen}
                    />
                  </div>
                </div>
              </div>
              <div className='field'>
                <label className='label-title' htmlFor='expmedJuicclin'>
                  Juicio clínico
                </label>
                <div className='control'>
                  <textarea
                    className='textarea'
                    name='expmedJuicclin'
                    id='expmedJuicclin'
                    readOnly
                    value={expmedJuicclin}
                  ></textarea>
                </div>
              </div>
            </fieldset>
          </form>
        ))}
      </div>
      {!errorMessage &&
      <div id='actions'>
      {((diffDate <= 72 && props.userRole.includes('medicina')) || props.userRole.includes('administrador')) && (
        <Link className='button is-link' to={`edit`}>
          Editar
        </Link>
      )}
      </div>
      }
    </>
  );
}
